module.exports = {
      id: "image-gallery-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svg-sprite-c71831da97eff2ec188167649c252867.svg#image-gallery",
      toString: function () {
        return this.url;
      }
    }